import { Button, Input, Space, Table } from "antd";
import React, { useRef, useState } from "react";
import Style from "./PublicDiscountListTabel.module.scss";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Check2, PencilSquare, XLg } from "react-bootstrap-icons";
import { separate } from "../../../../Utils/SeprateNumber/SeprateThreeNumber";
import moment from "moment-jalaali";
import { JalaliDate } from "../../../../Utils/JalaliDate/JalaliDate";

const PublicDiscountListTabel = ({ openModal, data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  let dataSource = [];
  data &&
    data.forEach((element,index) => {
        dataSource.push({
            key:index+1,
            id:element.id,
            type:element.type==="const"?'ثایت':"درصد",
            typeEncrypted:element.type,
            discount:element.discount,
            value:element.value,
            start_date:JalaliDate(element.start_date),
            end_date:JalaliDate(element.end_date),
            min_cart:separate(element.min_cart),
            max_cart:separate(element.max_cart),
            usage_limit:element.usage_limit,
            used_count:element.used_count,
        })
    });
  const columns = [
    {
      title: "ردیف",
      dataIndex: "key",
      key: "key",
      width: "5%",

    },
    {
      title: "نوع تخفیف",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "کد تخفیف",
      dataIndex: "discount",
      key: "discount",
      ...getColumnSearchProps("discount", "کد تخفیف"),
    },
    {
      title: "مقدار تخفیف",
      dataIndex: "value",
      key: "value",
    },
    {
      title: "زمان شروع تخفیف تخفیف",
      dataIndex: "start_date",
      key: "start_date",
    },
    {
      title: "زمان پایان تخفیف تخفیف",
      dataIndex: "end_date",
      key: "end_date",
    },
    {
      title: "حداقل سبد خرید",
      dataIndex: "min_cart",
      key: "min_cart",
    },
    {
      title: "حداکثر سبد خرید",
      dataIndex: "max_cart",
      key: "max_cart",
    },
    {
      title: "تعداد دفعه قابل استفاده",
      dataIndex: "usage_limit",
      key: "usage_limit",
    },
    {
      title: "تعداد دفعه استفاده شده",
      dataIndex: "used_count",
      key: "used_count",
    },
    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      width: "20%",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          <button
            onClick={() => openModal(1, record)}
            className={Style.editBtn}
          >
            <PencilSquare />
          </button>
          <button
              onClick={() => openModal(2, record)}
              className={Style.deleteBtn}
            >
              <XLg />
            </button>
        </div>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }} className={Style.TabelHolder}>
      <Table
        pagination={{ pageSize: 5 }}
        columns={columns}
        dataSource={dataSource}
        loading={data === undefined ? true : false}
      />
    </div>
  );
};

export default PublicDiscountListTabel;
